import React,{useEffect,useState} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import Button from '@mui/material/Button';
import reportService from '../../services/reportService';
import { LoadingSpinner } from '../../components';
import moment from 'moment';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };


const rows = [
    {
      "leagueName" : "Myanmar National League",
      "postingNo" : "GB343434343434",
      "homeTeam" : "Shan Utd",
      "awayTeam" : "Magway FC",
      "odd" : "1+30",
      "bettedTeam" : "Shan Utd",
      "555Odd" : "1+10" ,
      "amount" : 4000
    },
    {
        "leagueName" : "Myanmar National League",
        "postingNo" : "GB343434343434",
        "homeTeam" : "Shan Utd",
        "awayTeam" : "Magway FC",
        "odd" : "1+30",
        "bettedTeam" : "Shan Utd",
        "555Odd" : "1+10",
        "amount" : 4000
    },
    {
        "leagueName" : "Myanmar National League",
        "postingNo" : "GB343434343434",
        "homeTeam" : "Shan Utd",
        "awayTeam" : "Magway FC",
        "odd" : "1+30",
        "bettedTeam" : "Shan Utd",
        "555Odd" : "1+10",
        "amount" : 4000
    },
    {
        "leagueName" : "Myanmar National League",
        "postingNo" : "GB343434343434",
        "homeTeam" : "Shan Utd",
        "awayTeam" : "Magway FC",
        "odd" : "1+30",
        "bettedTeam" : "Shan Utd",
        "555Odd" : "1+10",
        "amount" : 4000
    },
    {
        "leagueName" : "Myanmar National League",
        "postingNo" : "GB343434343434",
        "homeTeam" : "Shan Utd",
        "awayTeam" : "Magway FC",
        "odd" : "1+30",
        "bettedTeam" : "Shan Utd",
        "555Odd" : "1+10",
        "amount" : 4000
    },
    {
        "leagueName" : "Myanmar National League",
        "postingNo" : "GB343434343434",
        "homeTeam" : "Shan Utd",
        "awayTeam" : "Magway FC",
        "odd" : "1+30",
        "bettedTeam" : "Shan Utd",
        "555Odd" : "1+10",
        "amount" : 4000
    },
    {
        "leagueName" : "Myanmar National League",
        "postingNo" : "GB343434343434",
        "homeTeam" : "Shan Utd",
        "awayTeam" : "Magway FC",
        "odd" : "1+30",
        "bettedTeam" : "Shan Utd",
        "555Odd" : "1+10",
        "amount" : 4000
    },
    {
        "leagueName" : "Myanmar National League",
        "postingNo" : "GB343434343434",
        "homeTeam" : "Shan Utd",
        "awayTeam" : "Magway FC",
        "odd" : "1+30",
        "bettedTeam" : "Shan Utd",
        "555Odd" : "1+10",
        "amount" : 4000
    },
    {
        "leagueName" : "Myanmar National League",
        "postingNo" : "GB343434343434",
        "homeTeam" : "Shan Utd",
        "awayTeam" : "Magway FC",
        "odd" : "1+30",
        "bettedTeam" : "Shan Utd",
        "555Odd" : "1+10",
        "amount" : 4000
    }
]

const DiffOddVoucherReport = () => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(8);
    const [showData,setShowData] = React.useState([]);
    const [isLoading, setIsLoading] = useState(false);
  
    // useEffect(() => {
    //   //  getDiffOddVouchers();
    // },[])

    const getDiffOddVouchers = async () => {
        setIsLoading(true);
        const differentOddList = await reportService.getDifferentOddVouchers();
    
        const temp = differentOddList && differentOddList.data.data.vouchers.map((v,i) => {
           let prev = differentOddList.data.data.result.filter(value => parseInt(value.event_Id_909) == parseInt(v.rapidEventId) && moment(value.createdAt.value).format("YYYY-MM-DD HH:mm") <= moment(v.createdDate).format("YYYY-MM-DD HH:mm"));
           let next = differentOddList.data.data.result.filter(value => parseInt(value.event_Id_909) == parseInt(v.rapidEventId) && moment(value.createdAt.value).format("YYYY-MM-DD HH:mm") == moment(v.createdDate).format("YYYY-MM-DD HH:mm"));
           
           let prevInfo = prev && prev[0];
           let nextInfo = next && next[next.length-1];
   
           //console.log("prevInfo",prevInfo,nextInfo,v.createdDate,);

           if(prevInfo !== undefined || nextInfo !== undefined){
               let next_gdiff = false;let next_bdiff = false;

               let prev_gdiff = prevInfo.is_goal_diff;
               let prev_bdiff = prevInfo.is_body_diff;
               
               if(nextInfo !== undefined){
                   next_gdiff = nextInfo.is_goal_diff;
                   next_bdiff = nextInfo.is_body_diff;
               }

               return {
                    postingNo : v.postingNo,
                    gamblingId : v.gamblingId,
                    homeTeam : prevInfo.event_909_home,
                    awayTeam : prevInfo.event_909_away,
                    amount : v.amount,
                    bettedTeam : !v.overs && !v.under ? v.footballTeam : `${v.footballTeam}(${v.overs? 'Over' : 'Under'})` ,
                    leagueName : v.leagueName,
                    odd : !v.overs && !v.under ? v.bodyOdd : v.goalOdd,
                    odd555 : !v.overs && !v.under ? prevInfo.away_odd_555 === "null" ? prevInfo.home_odd_555 : prevInfo.away_odd_555 : prevInfo.goal_odd_555,
                    isUpper : (v.isHomeBodyOdd && v.home) || (!v.isHomeBodyOdd && v.away) ? true : false,
                    isOddDiff :  !v.overs && !v.under ? prev_bdiff ? diffOddMethod(v.bodyOdd, prevInfo.away_odd_555 === "null" ? prevInfo.home_odd_555 : prevInfo.away_odd_555) : prev_bdiff : prev_gdiff ? diffOddMethod(v.goalOdd,prevInfo.goal_odd_555) : prev_gdiff,
                    isOver : v.overs,
                    isUnder : v.under,
                    createdAt : moment(v.createdDate).format("YYYY-MM-DD HH:mm"),
                    prev : prevInfo,
                    next : nextInfo
               } 
           }
       })

       console.log("prevInfo",temp.filter(value => value !== undefined && value.isOddDiff === true));
       console.log("final >>>",differentOddList.data.data.vouchers.length);

       setShowData(temp.filter(value => value !== undefined && value.isOddDiff === true));
       setIsLoading(false);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
      const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };

      const diffOddMethod = (odd909,odd555) => {
        console.log("ddddd",odd555,odd909);
        var firstOdd = splitMethod(odd909);
        var secondOdd = splitMethod(odd555);
        let isChange;
        if (firstOdd.goal == secondOdd.goal) {
            if (firstOdd.unit <= 0 && secondOdd.unit <= 0) {
                let tempOdds = Math.abs(firstOdd.unit) - Math.abs(secondOdd.unit);
                if (Math.abs(tempOdds) >= 15) {
                    isChange = true;
                }
                else {
                    isChange = false;
                }
            }
            else if (firstOdd.unit >= 0 && secondOdd.unit >= 0) {
                let tempOdds = Math.abs(firstOdd.unit) - Math.abs(secondOdd.unit);
                if (Math.abs(tempOdds) >= 15) {
                    isChange = true;
                }
                else {
                    isChange = false;
                }
            }
            else {
                if (firstOdd.unit == 0 || secondOdd.unit == 0) {
                    let tempOdds = Math.abs(firstOdd.unit) - Math.abs(secondOdd.unit);
                    if (Math.abs(tempOdds) >= 15) {
                        isChange = true;
                    }
                    else {
                        isChange = false;
                    }
                }
                else {
                    isChange = true;
                }
            }
        }
        else {
            if (firstOdd.unit <= 0 && secondOdd.unit <= 0) {
                isChange = true;
            }
            else if (firstOdd.unit > 0 && secondOdd.unit > 0) {
                isChange = true;
            }
            else {
                if (secondOdd.unit >= 0 && firstOdd.unit <= 0) {
                    var count = 0;
                    if (firstOdd.unit == -100) {
                        firstOdd.unit = Math.abs(firstOdd.unit);
                    }
    
                    while (firstOdd.unit != secondOdd.unit) {
                        firstOdd.unit -= 5;
                        if (firstOdd.unit == -100) {
                            firstOdd.unit = Math.abs(firstOdd.unit);
                        }
                        count++;
                    }
                    if (count * 5 >= 15) {
                        isChange = true;
                    }
                    else {
                        isChange = false;
                    }
                }
                else {
                    var count = 0;
                    if (secondOdd.unit == -100) {
                        secondOdd.unit = Math.abs(secondOdd.unit);
                    }
                    while (secondOdd.unit != firstOdd.unit) {
                        secondOdd.unit -= 5;
                        if (secondOdd.unit == -100) {
                            secondOdd.unit = Math.abs(secondOdd.unit);
                        }
                        count++;
                    }
                    if (count * 5 >= 15) {
                        isChange = true;
                    }
                    else {
                        isChange = false;
                    }
                }
            }
        }
    
        return isChange;
    }
    
    const splitMethod = (inputString) => {
        let resultArray = [];
        if (inputString.includes('=')) {
             resultArray = inputString.split('=');
            return {
                goal: "0",
                unit: resultArray[1] === "D" ? 0 : resultArray[1]
            }
        } else {
            resultArray = inputString.split(/([-+])/);
            return {
                goal: resultArray[0],
                unit: resultArray[1] + resultArray[2]
            }
        }
    }

    const handleReject = async(gid) => {
        const payload = {
            gamblingId : gid,
            status :"Inplay"
        }

        await reportService.rejectVoucher(payload);
    }

    return (
        <div className='container mx-auto px-4'>
            <div className='flex justify-between items-center'>
               <h1 className='text-lg py-2 my-2'>DiffOddVoucherReport</h1>
            </div>
            {isLoading ? <LoadingSpinner /> : 
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead className='bg-gray-200 text-white' style={{color:"white"}}>
                        <TableRow>
                        <TableCell>No</TableCell>
                            <TableCell align="left">Voucher</TableCell>
                            <TableCell align="left">Amount</TableCell>
                            <TableCell align="left">Bet</TableCell>
                            <TableCell align="left">Odd</TableCell>
                            <TableCell align="left">555Odd</TableCell>
                            <TableCell align="left">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                        showData
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row,index) => (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                   <TableCell align="left">{index + 1}</TableCell>
                                <TableCell align="left">
                                   <span className='text-xs'>{row.postingNo}</span><br/>
                                    {row.homeTeam} vs {row.awayTeam}&nbsp;&nbsp;({row.leagueName})
                                </TableCell>
                                <TableCell align="left">{row.amount}</TableCell>
                                <TableCell align="left"><span style={{color : `${row.isOver ? 'red' : row.isUnder ? 'green' : row.isUpper ? 'red' : 'green'}`,fontWeight:500}}>{row.bettedTeam}</span></TableCell>
                                <TableCell align="left">{row.odd}</TableCell>
                                <TableCell align="left">{row.odd555}</TableCell>
                                <TableCell align="left">
                                <Button variant="contained" style={{width : '50%'}} onClick={()=>handleReject(row.gamblingId)}>Reject</Button>
                                    </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={showData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              slotProps={{
                select: {
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                },
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              
            />
          </TableRow>
        </TableFooter>
                </Table>
            </TableContainer>
}
        </div>
    )
}

export default DiffOddVoucherReport;

// 20240328153115
// http://localhost:8000/api/v1/different-odd/odd-summary







   